import React, { useEffect, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { useLocation } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { useParams } from "react-router-dom";
import { errorAlert, successAlert } from "../services/sweetAlert";
import { apiRequest } from "../services/allApi";
import Loader from "../component/loader.jsx";

function TourDetail() {
  const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
  const [isLoading, setIsLoading] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const { slug } = useParams();

  const [tour, setTour] = useState(null);
  const getTour = async () => {
    setIsLoading(true);

    try {
      const res = await apiRequest(`tour/${slug}`);
      setIsLoading(false);
      if (res?.success) {
        setTour(res.data);
      } else {
        errorAlert(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getTour();
  }, [slug]);

  const images = tour?.images?.length
    ? tour.images.map((img) => `${BASE_URL}${img.image}`)
    : tour?.image
      ? [`${BASE_URL}${tour.image}`]
      : [];

  const handleDownload = async () => {
    try {
      const pdfUrl = `${BASE_URL}/uploads/tours/pdf/${tour?.tour_pdf}`;

      // 1️⃣ PDF open in new tab (view)
      window.open(pdfUrl, "_blank");

      // 2️⃣ Download PDF
      const response = await fetch(pdfUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = tour?.tour_pdf;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const [open, setOpen] = useState(false);

  const [index, setIndex] = useState(0);
  // 1. सबसे पहले Initial State को खाली वैल्यूज के साथ सेट करें
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "Tour Inquiry",
    comments: "", // Input field का 'name' attribute यही रखें
    travel_date: "", // Input field का 'name' attribute यही रखें
  });

  // 2. इनपुट बदलने पर स्टेट अपडेट करने के लिए
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // 3. फॉर्म सबमिट करते समय API कॉल
  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    // अगर आपकी API को 'comments' की जगह 'message' नाम से डेटा चाहिए,
    // तो यहाँ उसे बदल कर भेजें:
    const payload = {
      ...formData,
      message: formData.comments, // यहाँ मैपिंग करें
      date: formData.travel_date, // यहाँ मैपिंग करें
    };

    try {
      const res = await apiRequest("home-inquiry", "POST", payload);
      setIsLoading(false);
      if (res?.success) {
        successAlert(res.message);
      } else {
        errorAlert(res.message);
      }
    } catch (error) {
      console.error("Inquiry error", error);
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div
        className="modal fade"
        id="inquiryModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <button type="button" className="close" data-bs-dismiss="modal">
                <span>&times;</span>
              </button>

              <h4>Get me a quote</h4>

              <div className="row">
                <h5 className="trip-title">Fixed Car Group Trip</h5>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="row enquiry_row">
                  {/* NAME */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="required">Full name</label>
                      <input
                        className="form-control"
                        name="name"
                        placeholder="Your full name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  {/* PHONE */}
                  <div className="col-md-6">
                    <label className="required">Phone number</label>
                    <div className="row">
                      <div className="col-8">
                        <input
                          type="tel"
                          className="form-control"
                          name="phone"
                          placeholder="9999955555"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  {/* EMAIL */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="required">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        placeholder="youremail@domain.com"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  {/* DATE */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Preferred travel date</label>
                      <input
                        type="date"
                        className="form-control"
                        name="travel_date"
                        value={formData.travel_date}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* COMMENTS */}
                  <div className="col-12">
                    <div className="form-group">
                      <label>Additional comments / message</label>
                      <textarea
                        className="form-control"
                        name="comments"
                        rows="3"
                        placeholder="Tell us about your travel plans..."
                        value={formData.comments}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* SUBMIT */}
                  <div className="col-12 text-center mt-3">
                    <button className="btn btn-primary">Submit Inquiry</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>{" "}
      <div className="container pt-7">
        <div className="tour-gallery">
          {/* BIG IMAGE */}
          <div
            className="gallery-big"
            onClick={() => {
              setIndex(0);
              setOpen(true);
            }}
          >
            <img src={images[0]} alt={tour?.title} />
          </div>

          {/* RIGHT GRID */}
          <div className="gallery-small-wrap">
            {images.slice(1, 4).map((img, i) => (
              <div
                key={i}
                className="gallery-small"
                onClick={() => {
                  setIndex(i + 1);
                  setOpen(true);
                }}
              >
                <img src={img} alt={tour?.title} />
              </div>
            ))}

            <div
              className="gallery-view-all"
              onClick={() => {
                setIndex(0);
                setOpen(true);
              }}
            >
              <img src={images[0]} alt={tour?.title} />
              <button>📷 View All Images</button>
            </div>
          </div>
        </div>

        {/* LIGHTBOX */}
        <Lightbox
          open={open}
          close={() => setOpen(false)}
          slides={images.map((src) => ({ src }))}
        />
      </div>
      <div className="section-full bg-light mt-5 pt-5">
        <div className="container">
          <div className="section-content">
            <div className="row justify-content-center">
              {/* ================= LEFT SIDE ================= */}
              <div className="col-xl-8 col-lg-8 col-md-12 m-b30">
                <div className="ladhak-motodrive-detail-main-wrap">
                  <div className="ladhak-motodrive-detail-bx-wrap">
                    <div className="ladhak-motodrive-inr-para2">
                      {/* Rating */}
                      <div className="ladhak-motodrive-rating"></div>

                      <h3 className="ladhak-motodrive-inner-title-lg">
                        {/* Leh Ladakh Adventure Tour – Land of High Passes */}
                        {tour?.title}
                      </h3>

                      <span className="ladhak-motodrive-packege-esti-time">
                        {/* 2N Leh | 1N Nubra Valley | 1N Pangong Lake | 2N Leh */}
                        {tour?.route}
                      </span>
                      <span className="ladhak-motodrive-packege-esti-time">
                        {/* 2N Leh | 1N Nubra Valley | 1N Pangong Lake | 2N Leh */}
                        {tour?.duration}
                      </span>

                      {/* ================= SWIPER ================= */}
                      <div className="ladhak-motodrive-detail-slider">
                        <Swiper
                          modules={[Pagination]}
                          pagination={{ clickable: true }}
                          spaceBetween={20}
                          slidesPerView={1}
                        >
                          {images.map((img, index) => (
                            <SwiperSlide key={index}>
                              <div className="ladhak-motodrive_d-slider-media">
                                <img src={img} alt={`slide-${index}`} />
                              </div>
                            </SwiperSlide>
                          ))}
                        </Swiper>
                      </div>

                      {tour?.short_description && (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: tour.short_description,
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <br />
                <div className="ladhak-motodrive-detail-bx-wrap">
                  {tour?.description && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: tour.description,
                      }}
                    />
                  )}
                </div>
              </div>

              {/* ================= RIGHT SIDEBAR ================= */}
              <div className="col-xl-4 col-lg-4 col-md-12 rightSidebar mb-30">
                <aside className="side-bar">
                  {/* PRICE CARD */}
                  <div className="ladhak-motodrive-tour-single-r-detail">
                    <span className="ladhak-motodrive-star-from">
                      Starting from
                    </span>

                    <span className="ladhak-motodrive-star-amount">
                      <s>{tour?.mrp}</s> {tour?.price}
                    </span>

                    {/* <span className="ladhak-motodrive-star-from-person">
                      / Person
                    </span> */}

                    <div className="ladhak-motodrive-emi_text">
                      <i className="bi bi-wallet"></i>
                      No Cost EMI Starts from
                      {/* <span className="ladhak-motodriveng-binding">
                        {" "}
                        $<span className="ladhak-motodriveng-binding">49</span>
                      </span>
                      <a href="#" className="chsemi">
                        See option
                      </a> */}
                    </div>

                    <button
                      type="button"
                      className="site-button butn-bg-shape"
                      data-bs-toggle="modal"
                      data-bs-target="#inquiryModal"
                    >
                      Enquire Now
                    </button>

                    {/* FIXED PDF LINK: Added /uploads/ manually */}
                    {tour?.tour_pdf && (
                      <button
                        onClick={handleDownload}
                        className="site-button butn-bg-shape mt-2 bg-warning"
                      >
                        📄 View & Download PDF
                      </button>
                    )}
                  </div>

                  {/* INFO CARD */}
                </aside>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TourDetail;
